// Koordinate stanice za prikaz na mapi. Isti podatak stiže pod različitim
// imenima zavisno od endpointa: `/station/online` vraća `slatitude` (sve malim
// slovima — Jackson tako serijalizuje geter `getSLatitude`), stara pretraga
// `/station/search` vraća `latitude`. Zato se čita više oblika, umesto da se
// mapa tiho ne prikaže kad se izvor stanica promeni.

const COORD_FIELDS = [
    ["slatitude", "slongitude"],
    ["sLatitude", "sLongitude"],
    ["latitude", "longitude"],
    ["lat", "lng"],
    // Poslednja stanica bez svojih koordinata: koordinate njene lokacije.
    ["llatitude", "llongitude"],
    ["lLatitude", "lLongitude"],
];

// Gruba rezerva po imenu za stanice bez koordinata u bazi. Nije zamena za
// podatak — pokriva samo veće gradove i zato se koristi tek na kraju.
const KNOWN_COORDS = {
    "beograd": [44.8176, 20.4633],
    "novi sad": [45.2671, 19.8335],
    "nis": [43.3209, 21.8954],
    "subotica": [46.1003, 19.6658],
    "kragujevac": [44.0128, 20.9114],
    "zlatibor": [43.7310, 19.7030],
    "cacak": [43.8914, 20.3497],
    "kraljevo": [43.7260, 20.6897],
    "leskovac": [42.9981, 21.9461],
    "vranje": [42.5514, 21.9000],
    "pirot": [43.1531, 22.5858],
    "zajecar": [43.9042, 22.2858],
    "uzice": [43.8586, 19.8486],
    "valjevo": [44.2750, 19.8903],
    "sabac": [44.7536, 19.6917],
    "smederevo": [44.6628, 20.9289],
    "pancevo": [44.8708, 20.6403],
    "zrenjanin": [45.3833, 20.3833],
    "sombor": [45.7747, 19.1122],
    "kikinda": [45.8286, 20.4650],
    "novi pazar": [43.1369, 20.5125],
    "jagodina": [43.9772, 21.2611],
    "pozarevac": [44.6219, 21.1869],
    "bor": [44.0736, 22.0969],
    "loznica": [44.5333, 19.2267],
    "sremska mitrovica": [44.9764, 19.6122],
    "vrsac": [45.1167, 21.3036],
    "negotin": [44.2264, 22.5311],
    "arandjelovac": [44.3075, 20.5561],
    "gornji milanovac": [44.0256, 20.4597],
    "budimpesta": [47.4979, 19.0402],
    "budapest": [47.4979, 19.0402],
};

function readPair(station, latKey, lngKey) {
    const lat = Number(station[latKey]);
    const lng = Number(station[lngKey]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    // (0, 0) je „nema podatka" upisan kao nula, ne tačka u Gvinejskom zalivu.
    if (lat === 0 && lng === 0) return null;
    return [lat, lng];
}

export default function stationCoords(station) {
    if (!station) return null;

    for (const [latKey, lngKey] of COORD_FIELDS) {
        const pair = readPair(station, latKey, lngKey);
        if (pair) return pair;
    }

    const name = (station.name || station.stationName || "").toLowerCase().trim();
    if (!name) return null;
    const firstWord = name.split(" ")[0];
    for (const [key, coords] of Object.entries(KNOWN_COORDS)) {
        if (name.includes(key) || (firstWord && key.includes(firstWord))) {
            return coords;
        }
    }

    return null;
}
